import React from "react";
import About from "./pages/about";
import Apply from "./pages/apply";
import SmoothScroll from "smooth-scroll";
import Home from "./pages/home";
import UnitedWeCan from "./pages/project-pages/unitedWeCan";
import VeteransTransitionNetwork from "./pages/project-pages/veteransTransitionNetwork";
import Success from "./pages/project-pages/success";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "./App.css";
import Projects from "./pages/projects";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {

  return (
    
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path = "/projects" element={<Projects/>}/>
        <Route path = "/projects/united-we-can" element={<UnitedWeCan/>}/>
        <Route path = "/projects/veterans-transition-network" element={<VeteransTransitionNetwork/>}/>
        <Route path = "/projects/success" element={<Success/>}/>
        {/*TODO: might be better to use a nested route instead? IDK if it'll be a significant benefit */}
        <Route path = "/about" element={<About/>}/>
        <Route path = "/apply" element={<Apply/>}/>
          

        {/*
        <Route path="/about" element={<About />} />
        <Route
          path="/contact"
          element={<Contact />}
        />
        <Route path="/blogs" element={<Blogs />} />
        <Route
          path="/sign-up"
          element={<SignUp />}
        />*/}
      </Routes>

    </Router>
  );
};

export default App;
